import { createSlice } from "@reduxjs/toolkit";
import {
    getAllNotificationList,
    updateExistingNotification,
    createNotificationForAll,
    deleteNotification,
    bulkDeleteNotifications
} from './thunk';

export const initialState = {
    notificationList: [],
    loading: false,
    error: null
};

const NotificationSlice = createSlice({
    name: 'Notification',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        // getAllNotificationList
        builder.addCase(getAllNotificationList.pending, (state: any) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getAllNotificationList.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.notificationList = action.payload;
            state.error = null;
        });
        builder.addCase(getAllNotificationList.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || 'Failed to fetch notifications';
        });

        // updateExistingNotification
        builder.addCase(updateExistingNotification.pending, (state: any) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(updateExistingNotification.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(updateExistingNotification.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || 'Failed to update notification';
        });

        // createNotificationForAll
        builder.addCase(createNotificationForAll.pending, (state: any) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(createNotificationForAll.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(createNotificationForAll.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || 'Failed to create notification';
        });

        // deleteNotification
        builder.addCase(deleteNotification.pending, (state: any) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(deleteNotification.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(deleteNotification.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || 'Failed to delete notification';
        });

        // bulkDeleteNotifications
        builder.addCase(bulkDeleteNotifications.pending, (state: any) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(bulkDeleteNotifications.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(bulkDeleteNotifications.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || 'Failed to delete notifications';
        });

    }
});

export const { clearError } = NotificationSlice.actions;
export default NotificationSlice.reducer;